import {
  ChangeDetectorRef,
  Component,
  HostListener,
  NgZone,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import {
  NavigationItem,
  navigationItemsWithPatient,
} from '../../models/navigation-item-model';
import { PatientService } from '../../services/patient.service';
import { CommonModule, DatePipe } from '@angular/common';
import {
  LabelAndDescription,
  NameAndWidth,
  PatientAppointment,
  PatientEssentialInfo,
  PatientNote,
  PatientReminder,
} from '../../models/patient-model';
import { FormsModule } from '@angular/forms';
import { LabelService } from '../../services/label.service';
import { newPatientAndAppointment } from '../../models/calendar-model';
import moment from 'moment';
import { ErrorPanelService } from '../../services/error-panel.service';
import { SidebarService } from '../../services/sidebar.service';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationPanelComponent } from '../../shared/confirmation-panel/confirmation-panel.component';
import { GoogleCalendarService } from '../../pages/calendar-page/google-calendar.service';
import { DbAppointmentsService } from '../../pages/calendar-page/db-appointments.service';
import { GmailService } from '../../services/gmail.service';

@Component({
  selector: 'app-interview-page',
  standalone: true,
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatTooltipModule,
  ],
  templateUrl: './interview-page.component.html',
  styleUrl: './interview-page.component.scss',
  providers: [DatePipe],
})
export class InterviewPageComponent implements OnInit {
  navigationItems: NavigationItem[] = [];

  isPatientActive: boolean = true;
  showNewInterviewPanel: boolean = false;
  showModifyAppointmentPanel: boolean = false;
  showDeleteAppointmentPanel: boolean = false;
  isInterviewSection: boolean = true;
  isNoteAndReminderSection: boolean = false;
  hasModifyButtonBeenClicked: boolean = false;

  isLoadingPastAppointments: boolean = true;
  isLoadingFutureAppointments: boolean = true;
  isLoadingNotes: boolean = true;
  isLoadingReminders: boolean = true;

  patientId: string = '';
  patientName: string = '';
  patientSurname: string = '';
  patientNameAndSurname: string = '';

  notes: PatientNote[] = [];
  selectedNote: PatientNote = {
    id: '',
    patientId: '',
    dateLastModified: '',
    description: '',
  };

  reminders: PatientReminder[] = [];
  filteredReminders: PatientReminder[] = [];
  selectedReminder: PatientReminder = {
    id: '',
    patientId: '',
    description: '',
    completed: false,
    dateLastModified: '',
  };

  isNewAppointmentRemote: boolean = false;
  futureAppointments: PatientAppointment[] = [];
  pastAppointments: PatientAppointment[] = [];
  appointmentsToBeDisplayed: PatientAppointment[] = [];

  newInterviewTitle: string = '';
  newInterviewDay: string = '';
  newInterviewTime: string = '';
  selectedAppointment: any = {};

  inputBoxesForModifyAppointment: LabelAndDescription[] = [];
  modifyAppointment_title: string = '';
  modifyAppointment_day: string = '';
  modifyAppointment_month: string = '';
  modifyAppointment_year: string = '';
  modifyAppointment_hours: string = '';
  modifyAppointment_minutes: string = '';
  modifyAppointment_lenght: string = '';

  tableTitle = 'appointments';
  tableColumns: NameAndWidth[] = [
    { name: 'date', width: '40%' },
    { name: 'title', width: '60%' },
  ];
  displayedColumns: string[] = ['date', 'title', 'actions'];

  todayDate: Date = new Date();
  todayDateFormatted = this.datePipe.transform(this.todayDate, 'dd/MM/yyyy')!;
  isPastAppointmentsSelected: string = 'selected';
  isFutureAppointmnetsSelected: string = 'not-selected';

  isMobile = window.innerWidth < 930;
  isMobilePortrait = window.innerWidth < 730;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private patientService: PatientService,
    public labelService: LabelService,
    private datePipe: DatePipe,
    private changeDetectorRef: ChangeDetectorRef,
    public errorPanelService: ErrorPanelService,
    private sidebarService: SidebarService,
    private dialog: MatDialog,
    private zone: NgZone,
    private googleCalendarService: GoogleCalendarService,
    private dbAppointmentsService: DbAppointmentsService,
    private gmailService: GmailService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.patientService
        .getPatientEssentialInfo(params['patientId'])
        .subscribe({
          next: (data: PatientEssentialInfo) => {
            this.patientId = data.id;
            this.patientName = data.first_name;
            this.patientSurname = data.last_name;
            this.isPatientActive = data.is_active;
            this.patientNameAndSurname = `${this.patientName} ${this.patientSurname}`;
            this.navigationItems = this.sidebarService.updateNavigationItems(
              navigationItemsWithPatient,
              this.patientName,
              this.patientSurname,
              this.patientId
            );
            this.loadPatientData();
          },
          error: (err) => {
            console.error('Error getting patient essential info:', err);
            this.errorPanelService.showErrorSnackBar(
              'Errore nel recuperare i dati del paziente'
            );
          },
        });
    });
  }

  loadPatientData() {
    this.getNotes();
    this.getReminders();
    this.getAppointments();
  }

  getNotes(): void {
    this.isLoadingNotes = true;
    this.notes = [];
    this.patientService.getNotes(this.patientId).subscribe({
      next: (data) => {
        data.map((note: any) => {
          var obj: PatientNote = {
            id: note.id,
            patientId: note.patient_id,
            dateLastModified: note.date_last_modified,
            description: note.description,
          };
          this.notes.push(note);
        });
        this.isLoadingNotes = false;
      },
      error: (err) => {
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare le note del paziente'
        );
      },
    });
  }

  getReminders(): void {
    this.isLoadingReminders = true;
    this.reminders = [];
    this.filteredReminders = [];
    this.patientService.getReminders(this.patientId).subscribe({
      next: (data) => {
        data.map((reminder: any) => {
          var obj: PatientReminder = {
            id: reminder.id,
            patientId: reminder.patient_id,
            dateLastModified: reminder.date_last_modified,
            description: reminder.description,
            completed: reminder.completed,
          };
          this.reminders.push(obj);
          if (!obj.completed) {
            this.filteredReminders.push(obj);
          }
        });
        this.isLoadingReminders = false;
      },
      error: (err) => {
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare i promemoria del paziente'
        );
      },
    });
  }

  getAppointments(): void {
    this.isLoadingFutureAppointments = true;
    this.isLoadingPastAppointments = true;
    this.pastAppointments = [];
    this.futureAppointments = [];
    this.patientService.getAppointments(this.patientId).subscribe({
      next: (data) => {
        const now = new Date();
        data.forEach((appointment: PatientAppointment) => {
          const [day, month, year] = appointment.date.split('/');
          const [hours, minutes] = appointment.start_time.split(':');
          const appointmentDateTime = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day),
            parseInt(hours),
            parseInt(minutes)
          );

          if (appointmentDateTime >= now) {
            this.futureAppointments.push(appointment);
          } else {
            this.pastAppointments.push(appointment);
          }
        });
        this.isLoadingFutureAppointments = false;
        this.isLoadingPastAppointments = false;
        this.sortAppointments();
      },
      error: (error) => {
        console.error('Errore nel recuperare gli appuntamenti', error);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare gli appuntamenti'
        );
      },
    });
  }

  parseDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return date;
  }

  sortAppointments() {
    this.futureAppointments.sort((a, b) => {
      var date_a = this.parseDate(a.date);
      var date_b = this.parseDate(b.date);
      return date_a.getTime() - date_b.getTime();
    });
    this.pastAppointments.sort((b, a) => {
      var date_a = this.parseDate(a.date);
      var date_b = this.parseDate(b.date);
      return date_a.getTime() - date_b.getTime();
    });
    this.appointmentsToBeDisplayed = this.pastAppointments;
    this.isPastAppointmentsSelected = 'selected';
    this.isFutureAppointmnetsSelected = 'not-selected';
    this.changeDetectorRef.detectChanges();
  }

  displayPastAppointmentSection() {
    this.isPastAppointmentsSelected = 'selected';
    this.isFutureAppointmnetsSelected = 'not-selected';
    this.appointmentsToBeDisplayed = this.pastAppointments;
  }
  displayFutureAppointmentSection() {
    this.isPastAppointmentsSelected = 'not-selected';
    this.isFutureAppointmnetsSelected = 'selected';
    this.appointmentsToBeDisplayed = this.futureAppointments;
  }

  navigateInterviewDetails(appointment: PatientAppointment): void {
    const appointmentTitle = appointment.title
      .replaceAll(' ', '-')
      .replaceAll('/', '-');

    this.router.navigate(
      ['/pazienti', this.patientId, 'appointments', appointment.id, 'ai'],
      {
        state: {
          appointmentSelected: appointment,
          appointmentTitle: appointmentTitle,
        },
      }
    );
  }

  toggleInOffice(): void {
    this.isNewAppointmentRemote = false;
  }

  toggleOnline(): void {
    this.isNewAppointmentRemote = true;
  }

  toggleNewInterviewPanel(): void {
    this.showNewInterviewPanel = !this.showNewInterviewPanel;
  }

  confirmNewInterview(newEvent: newPatientAndAppointment): void {
    this.googleCalendarService
      .addPatientInterviewAppointment(newEvent)
      .then((response: any) => {
        const newAppointment = {
          patient_id: this.patientId,
          date: newEvent.date,
          start_time: newEvent.time,
          end_time: this.calculateEndTime(newEvent.time, newEvent.lenght),
          title: newEvent.title,
          google_calendar_event_id: response.result.id,
          is_remote: newEvent.isRemote,
        };

        this.zone.run(() => {
          this.patientService.createAppointment(newAppointment).subscribe({
            next: (resp) => {
              this.toggleNewInterviewPanel();
              this.getAppointments();
              this.gmailService.prepareEmailForClient(resp);
            },
            error: (err) => {
              console.error('Errore nel creare appuntamento', err);
              this.toggleNewInterviewPanel();
              this.errorPanelService.showErrorSnackBar(
                'Errore nel creare appuntamento'
              );
            },
          });
        });
      })
      .catch((error) => {
        console.error('Error creating appointment:', error);
        this.zone.run(() => {
          this.toggleNewInterviewPanel();
          this.errorPanelService.showErrorSnackBar(
            "Errore nel creare l'evento nel calendario"
          );
        });
      });
  }

  modifyAppointment(appointment?: PatientAppointment) {
    this.showModifyAppointmentPanel = !this.showModifyAppointmentPanel;
    this.changeDetectorRef.detectChanges();
    if (appointment) {
      this.selectedAppointment = appointment;
      this.modifyAppointment_title = appointment.title;
      this.modifyAppointment_day = appointment.date.split('/')[0];
      this.modifyAppointment_month = appointment.date.split('/')[1];
      this.modifyAppointment_year = appointment.date.split('/')[2];
      this.modifyAppointment_hours = appointment.start_time.split(':')[0];
      this.modifyAppointment_minutes = appointment.start_time.split(':')[1];
      if (appointment.end_time) {
        this.modifyAppointment_lenght = this.calculateDifference(
          appointment.start_time,
          appointment.end_time
        );
      }
    } else {
      this.selectedAppointment = {};
      this.modifyAppointment_title = '';
      this.modifyAppointment_day = '';
      this.modifyAppointment_month = '';
      this.modifyAppointment_year = '';
      this.modifyAppointment_hours = '';
      this.modifyAppointment_minutes = '';
      this.modifyAppointment_lenght = '';
    }
  }

  confirmModifyAppointment(newEvent: newPatientAndAppointment) {
    if (
      this.selectedAppointment.google_calendar_event_id &&
      this.selectedAppointment.google_calendar_event_id !== ''
    ) {
      this.googleCalendarService
        .modifyPatientInterviewAppointment(
          newEvent,
          this.selectedAppointment.google_calendar_event_id
        )
        .then((response: any) => {
          this.zone.run(() => {
            this.dbAppointmentsService
              .updatePatientAppointment(
                this.selectedAppointment.id,
                newEvent,
                response.result.id
              )
              .then(() => {
                this.modifyAppointment();
                this.getAppointments();
              })
              .catch((error) => {
                console.error('Error updating appointment:', error);
                this.errorPanelService.showErrorSnackBar(
                  "Errore nel modificare l'appuntamento"
                );
                this.modifyAppointment();
              });
          });
        })
        .catch((error) => {
          console.error('Error updating appointment:', error);
          this.errorPanelService.showErrorSnackBar(
            "Errore nel modificare l'appuntamento su google calendar"
          );
          this.modifyAppointment();
        });
    } else {
      this.dbAppointmentsService
        .updatePatientAppointment(this.selectedAppointment.id, newEvent)
        .then(() => {
          this.modifyAppointment();
          this.getAppointments();
        })
        .catch((error) => {
          console.error('Error updating appointment:', error);
          this.errorPanelService.showErrorSnackBar(
            "Errore nel modificare l'appuntamento"
          );
          this.modifyAppointment();
        });
    }
  }

  confirmDeleteAppointment(appointment: PatientAppointment) {
    const dialogRef = this.dialog.open(ConfirmationPanelComponent, {
      data: {
        title: 'Sei sicuro di voler eliminare questo appuntamento?',
      },
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        if (
          appointment.google_calendar_event_id &&
          appointment.google_calendar_event_id !== ''
        ) {
          this.googleCalendarService
            .deletePatientInterviewAppointment(
              appointment.google_calendar_event_id
            )
            .then(() => {
              this.zone.run(() => {
                this.dbAppointmentsService
                  .deletePatientAppointment(appointment.id)
                  .then(() => this.getAppointments())
                  .catch((error) => {
                    console.error('Error deleting appointment:', error);
                    this.errorPanelService.showErrorSnackBar(
                      "Errore nel cancellare l'appuntamento"
                    );
                  });
              });
            })
            .catch((error) => {
              console.error('Error deleting event:', error);
              this.errorPanelService.showErrorSnackBar(
                "Errore nel cancellare l'evento nel calendario"
              );
            });
        } else {
          this.dbAppointmentsService
            .deletePatientAppointment(appointment.id)
            .then(() => this.getAppointments())
            .catch((error) => {
              console.error('Error deleting appointment:', error);
              this.errorPanelService.showErrorSnackBar(
                "Errore nel cancellare l'appuntamento"
              );
            });
        }
      } else {
        console.log('Eliminazione annullata');
      }
    });
  }

  switchSectionMobile() {
    this.isInterviewSection = !this.isInterviewSection;
    this.isNoteAndReminderSection = !this.isNoteAndReminderSection;
  }

  onModifyButtonClick(): void {
    this.hasModifyButtonBeenClicked = !this.hasModifyButtonBeenClicked;
  }

  handleMenuAction(action: string, appointment: any) {
    switch (action) {
      case 'edit':
        this.modifyAppointment(appointment);
        break;
      case 'delete':
        this.confirmDeleteAppointment(appointment);
        break;
    }
  }

  // Funzione per convertire data e orario nei formati accettati
  convertDateTime(date: string, time: string): string {
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(
      2,
      '0'
    )}T${time}:00`;
  }

  combineDateAndTime(
    date: string,
    time: string,
    length: string
  ): { start: Date; end: Date } {
    const [day, month, year] = date.split('/');
    const fullDate = `${year}-${month}-${day}T${time}:00`; // Formatta la data e l'ora in formato ISO 8601
    const startTime = new Date(fullDate);
    const durationMinutes = parseInt(length);
    const endTime = new Date(startTime.getTime() + durationMinutes * 60000); // Aggiunge la durata in minuti alla data di inizio
    return { start: startTime, end: endTime };
  }

  calculateEndTime(startTime: string, lengthInMinutes: string): string {
    const timeParts = startTime.split(':'); // Dividi la stringa di orario in ore e minuti
    const duration = parseInt(lengthInMinutes); // Converti la stringa di durata in un numero intero
    const date = new Date(); // Crea un nuovo oggetto Date
    date.setHours(parseInt(timeParts[0]), parseInt(timeParts[1]), 0, 0); // Imposta ore, minuti, secondi e millisecondi dal startTime

    date.setMinutes(date.getMinutes() + duration); // Aggiunge la lunghezza in minuti al tempo

    // Formatta l'orario di fine per restituirlo come stringa "HH:mm"
    const hours = date.getHours().toString().padStart(2, '0'); // Assicurati che le ore siano sempre due cifre
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Assicurati che i minuti siano sempre due cifre

    return `${hours}:${minutes}`; // Restituisce il nuovo orario come stringa
  }

  calculateDifference(time1: string, time2: string): string {
    const timeFormat = 'HH:mm';

    const dateTime1 = moment(time1, timeFormat);
    const dateTime2 = moment(time2, timeFormat);
    const duration = moment.duration(dateTime2.diff(dateTime1));
    const minutes = duration.asMinutes();

    return String(Math.round(minutes));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
    this.isMobilePortrait = window.innerWidth < 730;
  }
}
